// extracted by mini-css-extract-plugin
export var aboveInput = "_o4-0";
export var actionButton = "_o4-5";
export var actionButtonContainer = "_o4-1";
export var actionIcon = "_o4-6";
export var aiInfoContainer = "_o4-2";
export var attachmentWrapper = "_o4-7";
export var bold = "_o4-3";
export var checkIcon = "_o4-8";
export var clickingRecipientBar = "_o4-11";
export var commentThreadSwitch = "_o4-a";
export var draftImage = "_o4-b";
export var draftImageContainer = "_o4-c";
export var draftImages = "_o4-e";
export var editButton = "_o4-g";
export var editor = "_o4-f";
export var editorContainer = "_o4-y";
export var editorErrorTooltipWrapper = "_o4-9";
export var headerDivider = "_o4-h";
export var icon = "_o4-i";
export var info = "_o4-j";
export var internal = "_o4-n";
export var internalDivider = "_o4-k";
export var internalMessage = "_o4-l";
export var messageInputCard = "_o4-m";
export var messageInputForm = "_o4-o";
export var messageInputFormInternal = "_o4-p";
export var options = "_o4-q";
export var publicMessageCustomer = "_o4-s";
export var publicMessageMerchant = "_o4-r";
export var removeImageButton = "_o4-d";
export var replyButtons = "_o4-t";
export var showSignatureButton = "_o4-u";
export var spinner = "_o4-v";
export var verticalButtonDivider = "_o4-4";
export var visibilitySelector = "_o4-w";
export var warning = "_o4-x";
export var wrappingText = "_o4-z";
export var writingInternalNoteTopBorder = "_o4-10";